// extracted by mini-css-extract-plugin
export default {"footerLogo":"MainFooter_footerLogo__Ds0ar","footer":"MainFooter_footer__U32SS","footerAnchor":"MainFooter_footerAnchor__mKSOA"};